"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRotationProgram = exports.isStringHTMLValid = void 0;
exports.emptyToUndefined = emptyToUndefined;
exports.getStringFromParam = getStringFromParam;
var htmlValidRegexp = /[-!$%^&*()_+|~=`\\#{}[\]:";'<>?,./]/;
var isStringHTMLValid = function (stringHTML) { return !htmlValidRegexp.test(stringHTML); };
exports.isStringHTMLValid = isStringHTMLValid;
function emptyToUndefined(arg) {
    if (typeof arg !== 'string')
        return arg;
    if (arg.trim() === '')
        return undefined;
    return arg;
}
function getStringFromParam(arg) {
    if (typeof arg === 'string')
        return arg;
    if (arg.length === 0)
        return '';
    return arg[0];
}
var week = function (rotation) { return (rotation === 1 ? 'week' : 'weeks'); };
var formatRotationProgram = function (on, off) {
    var rotationOff = off ? "- Off ".concat(off, " ").concat(week(off)) : '';
    var rotationText = on ? "On ".concat(on, " ").concat(week(on), " ").concat(rotationOff) : '';
    return rotationText;
};
exports.formatRotationProgram = formatRotationProgram;
//# sourceMappingURL=utils.js.map